<template>
	<base-content navIndex="2">
		<div class="index-header">
			<div class="width-1280 course-header">
				<div class="col-fff bold course-header-title">电子商户在线营销技能证书</div>
				<div class="col-fff course-header-sub">
					电子商务在线营销职业技能证书通常涵盖广泛的主题，包括数字营销、社交媒体管理、搜索引擎优化、在线广告和电子商务策略等。以下是一个可能的课程目录示例，用于电子商务在线营销职业技能证书。
				</div>
			</div>
		</div>
		<div class="bg-lin-ef">
			<div class="width-1280 plr-20">
				<el-row :gutter="20" class="pt-16">
					<el-col :span="16">
						<div class="course-schedule bg-fff">
							<div class="course-schedule-title bold col-333">电子商户在线营销职业技能证书</div>
							<div class="bold col-333 course-schedule-sub">学习路径</div>
							<div class="course-progress">
								<el-progress :percentage="percentage" :show-text="false" :stroke-width="20" define-back-color="#EFEFEF"></el-progress>
								<el-image class="course-progress-icon" :style="{left:`calc(${percentage}% - 20px)`}"
									:src="require('@/assets/images/course/run@2x.png')"></el-image>
							</div>
							<div class="flex align-c col-333 f16">
								<div class="s-w1">开始</div>
								<div class="s-w2 flex align-c justify-c">初露锋芒</div>
								<div class="s-w2 flex align-c justify-c">渐入佳境</div>
								<div class="s-w2 flex align-c justify-c">运用自如</div>
								<div class="s-w1 flex align-c justify-e">如火纯青</div>
							</div>
							<div class="flex align-c course-progress-s">
								<div class="s-w1">
									<el-image class="progress-s-icon"
										:src="require('@/assets/images/course/s-y.png')"></el-image>
								</div>
								<div class="s-w2 flex align-c justify-c">
									<el-image class="progress-s-icon"
										:src="require('@/assets/images/course/s-y.png')"></el-image>
								</div>
								<div class="s-w2 flex align-c justify-c">
									<el-image class="progress-s-icon"
										:src="require('@/assets/images/course/s-y.png')"></el-image>
								</div>
								<div class="s-w2 flex align-c justify-c">
									<el-image class="progress-s-icon"
										:src="require('@/assets/images/course/s-y.png')"></el-image>
								</div>
								<div class="s-w1 flex align-c justify-e">
									<el-image class="progress-s-icon"
										:src="require('@/assets/images/course/s-n.png')"></el-image>
								</div>
							</div>
						</div>
						<div>
							<el-collapse accordion v-model="activeName">
								<el-collapse-item class="accordion-item" v-for="(item,index) in accordionList" :key="index" :name="index" :class="activeName == index ? 'accordion-active' : ''">
								    <template slot="title">
								      <div class="accordion-title flex align-c justify-sb">
												<div class="bold col-333 f16">
													{{item.title}}
												</div>
												<div class="flex align-c">
													<el-image class="accordion-star"
														:src="item.lv == 0 ? startNo : startYes"></el-image>
													<el-image class="accordion-star"
														:src="item.lv >= 2 ? startYes : startNo"></el-image>
													<el-image class="accordion-star"
														:src="item.lv == 3 ? startYes : startNo"></el-image>
												</div>
											</div>
								    </template>
								    <div class="accordion-content">
											<div class="col-333 accordion-content-title">
												电子商务在线营销职业技能证书通常涵盖广泛的主题，包括数字营销、社交媒体管理、搜索引擎优化、在线广告和电子商务策略等。以下是一个可能的课程目录示例，用于电子商务在线营销职业技能证书：
											</div>
											<div class="flex align-c f16 bold">
												<div class="col-333">课程链接：</div>
												<div class="col-169">https://www.xxxxxxxxxxxxxxxxxxxx</div>
											</div>
											<div @click="study(item,index)" class="flex align-c justify-c" :class="item.lv == 3 ? 'accordion-btn1' : 'accordion-btn2'">{{item.lv == 3 ? '已完成' : '课程测试'}}</div>
										</div>
								  </el-collapse-item>
							</el-collapse>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="bg-fff course-right">
							<div class="course-right-title flex align-c col-333 bold">
								相关技能认证
							</div>
							<div class="course-right-item flex align-c justify-sb f16" v-for="(item,index) in skillList" :key="index">
								<div class="col-333">{{item.title}}</div>
								<div class="bold col-169">{{item.sub}}</div>
							</div>
							<div class="course-right-all flex align-c justify-c">查看全部技能</div>
						</div>
					</el-col>
				</el-row>
				<div class="course-hot bg-fff">
					<div class="hot-title flex align-c justify-sb">
						<div class="col-333 bold f16">热门课程</div>
						<div class="flex align-c">
							<div class="hot-more">查看更多课程</div>
							<el-image class="hot-icon"
								:src="require('@/assets/images/course/drop-down@2x.png')"></el-image>
						</div>
					</div>
					<div class="hot-list flex align-c flex-wrap">
						<el-image class="hot-img" v-for="(item,index) in hotList" :key="index"
							:src="item.img"></el-image>
					</div>
				</div>
				<div class="job-breadcrumb flex align-c">
					<el-image class="breadcrumb-home"
						:src="require('@/assets/images/job/home@2x.png')"></el-image>
					<el-breadcrumb separator="|">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item><a href="/course">课程资源</a></el-breadcrumb-item>
					  <el-breadcrumb-item>电子商务在线营销技能证书</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
		</div>
	</base-content>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	export default{
		components:{ baseContent },
		data(){
			return{
				skillList:[
					{title:'电子商务在线营销职业技能证书',sub:'未开始'},
					{title:'市场调研数字营销职业技能证书',sub:'初露锋芒'},
					{title:'用户体验设计交互职业技能证书',sub:'渐入佳境'},
					{title:'产品管理需求分析职业技能证书',sub:'开始'},
					{title:'产品管理用户体验设计职业技能证书',sub:'运用自如'},
					{title:'项目管理用户方向职业技能证书',sub:'如火纯青'},
				],
				percentage:75,
				accordionList:[
					{
						title:'第一部分 课程导入',
						sub:'',
						lv:3
					},
					{
						title:'第二部分 数字营销基础',
						sub:'',
						lv:3
					},
					{
						title:'第三部分 电子商务战略',
						sub:'',
						lv:3
					},
					{
						title:'第四部分 社交媒体管理',
						sub:'',
						lv:2
					},
					{
						title:'第五部分 内容营销管理',
						sub:'',
						lv:2
					},
					{
						title:'第六部分 搜索引擎优化',
						sub:'',
						lv:2
					},
					{
						title:'第七部分 搜索引擎广告',
						sub:'',
						lv:1
					},
					{
						title:'第八部分 电子邮件营销',
						sub:'',
						lv:1
					},
					{
						title:'第九部分 数据分析和报告',
						sub:'',
						lv:1
					},
					{
						title:'第十部分 营销优化',
						sub:'',
						lv:0
					},
					{
						title:'第十一部分 用户行为分析',
						sub:'',
						lv:0
					}
				],
				startYes:require('@/assets/images/course/star-y.png'),
				startNo:require('@/assets/images/course/star-n.png'),
				activeName:0,
				hotList:[
					{img:require('@/assets/images/course/1@2x.png')},
					{img:require('@/assets/images/course/2@2x.png')},
					{img:require('@/assets/images/course/3@2x.png')},
					{img:require('@/assets/images/course/4@2x.png')},
					{img:require('@/assets/images/course/5@2x.png')},
					{img:require('@/assets/images/course/6@2x.png')},
					{img:require('@/assets/images/course/7@2x.png')},
					{img:require('@/assets/images/course/8@2x.png')}
				],
			}
		},
		mounted() {
			
		},
		methods:{
			study(item,index){
				if(item.lv != 3){
					this.$router.push({path:'/study',query:{index}})
				}
			}
		}
	}
</script>

<style>
	.index-header{
		background: #39546A;
		height: 170px;
	}
	.course-header{
		padding: 26px 20px 0 20px;
	}
	.course-header-title{
		font-size: 28px;
		line-height: 40px;
	}
	.course-header-sub{
		margin-top: 16px;
		font-size: 16px;
		line-height: 26px;
	}
	.pt-16{
		padding-top: 16px;
	}
	.course-right{
		background: #FFFFFF;
		border-radius: 12px;
		overflow: hidden;
		padding-bottom: 36px;
	}
	.course-right-title{
		height: 48px;
		background: #F6FBFA;
		padding-left: 20px;
		font-size: 16px;
		line-height: 22px;
	}
	.course-right-item{
		margin: 16px 10px 0 10px;
		height: 50px;
		background: rgba(22,155,213,0.04);
		border-radius: 8px;
		padding: 0 10px;
	}
	.f16{
		font-size: 16px;
		line-height: 22px;
	}
	.col-169{
		color: #169BD5;
	}
	.course-right-all{
		width: 256px;
		height: 38px;
		border-radius: 10px;
		border: 1px solid #169BD5;
		margin: auto;
		margin-top: 36px;
		font-size: 16px;
		color: #169BD5;
	}
	.course-schedule{
		height: 268px;
		border-radius: 12px;
		padding: 26px 16px 0 16px;
	}
	.course-schedule-title{
		font-size: 32px;
		line-height: 45px;
	}
	.course-schedule-sub{
		font-size: 18px;
		line-height: 25px;
		margin-top: 32px;
	}
	.course-progress{
		height: 38px;
		position: relative;
		padding-top: 18px;
		margin-bottom: 12px;
	}
	.course-progress .el-progress-bar__inner{
		background: linear-gradient(270deg, #84E6FB 0%, #169BD5 100%);
	}
	.course-progress-icon{
		width: 44px;
		height: 44px;
		position: absolute;
		top: -2px;
	}
	.course-progress-s{
		margin-top: 18px;
		height: 4px;
		background: #2FCD98;
		border-radius: 3px;
	}
	.progress-s-icon{
		width: 20px;
		height: 20px;
	}
	.course-w5{
		width: 20%;
	}
	.s-w4{
		width: calc((100% - 40px) / 4);
	}
	.s-w1{
		width: calc(100% / 8);
	}
	.s-w2{
		width: 25%;
	}
	.accordion-item{
		border-radius: 12px;
		margin-top: 16px;
		overflow: hidden;
	}
	.accordion-item .el-collapse-item__header{
		width: 100%;
	}
	.accordion-title{
		padding-left: 16px;
		width: 100%;
	}
	.accordion-active .el-collapse-item__header{
		background: linear-gradient(270deg, #D5F1FA 0%, #ABDEF4 100%);
	}
	.accordion-star{
		width: 16px;
		height: 16px;
		margin-right: 10px;
	}
	.accordion-content{
		padding: 14px 16px 20px 16px;
	}
	.accordion-content-title{
		font-size: 16px;
		line-height: 28px;
		margin-bottom: 14px;
	}
	.accordion-btn1{
		width: 154px;
		height: 40px;
		border-radius: 8px;
		border: 1px solid #169BD5;
		margin: auto;
		margin-top: 24px;
		font-size: 13px;
		color: #169BD5;
	}
	.accordion-btn2{
		width: 154px;
		height: 40px;
		background: #169BD5;
		border-radius: 8px;
		margin: auto;
		margin-top: 24px;
		color: #fff;
		font-size: 13px;
	}
	.course-hot{
		/* width: 1240px; */
		margin: auto;
		margin-top: 20px;
		border-radius: 12px;
		overflow: hidden;
	}
	.hot-title{
		height: 48px;
		padding: 0 16px;
		background: #F6FBFA;
	}
	.hot-icon{
		width: 6px;
		height: 8px;
		margin-left: 12px;
	}
	.hot-more{
		font-size: 14px;
		color: #597670;
		line-height: 20px;
	}
	.plr-20{
		padding: 0 20px;
	}
	.hot-list{
		padding: 10px 13px 24px 13px;
	}
	.hot-img{
		width: 293px;
		height: 163px;
		margin: 16px 14px 0 0;
	}
	.hot-img:nth-child(4n){
		margin-right: 0;
	}
	.job-breadcrumb{
		height: 92px;
	}
	.breadcrumb-home{
		width: 16px;
		height: 16px;
		margin-right: 12px;
	}
</style>